import { render } from "./Menu.vue?vue&type=template&id=57422322"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "@/assets/css/Menu.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/legand/anomyma/commerce-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__